/**
 * Roles are stored as `SUPER_ADMIN` / `ADMIN` / `STAFF` in the API but labelled
 * "Super Admin" / "Admin" / "Staff" in the client, so names are compared in a
 * form where separators and casing do not matter.
 */
export const normalizeRoleName = (roleName: string): string =>
  roleName.trim().toLowerCase().replace(/[\s_-]+/g, '_');
